import { TaskStatusOption } from "models/tasks"

type TaskStatusCellProps = {
    status: TaskStatusOption
}

const getStatusDisplay = (status: TaskStatusOption) => {
    console.log(status?.toLowerCase());
    switch (status?.toLowerCase()) {
        case 'in-progress':
        case 'in progress':
        case 'inprogress':
            return 'In Progress';
        case 'upcoming':
            return 'Upcoming';
        case 'on-hold':
        case 'on hold':
        case 'onhold':
            return 'On Hold';
        case 'completed':
            return 'Completed';
        case 'cancelled':
            return 'Cancelled';
    }
}

const TaskStatusCell = (props: TaskStatusCellProps) => (<span>{getStatusDisplay(props.status)}</span>);

export default TaskStatusCell;